import strings from 'strings';
import { CompanyEntity, ListingFilters } from 'UI/constants/entityTypes';

const { searchProject: formCopies } = strings.searchProjects.forms;

const NON_FILTER_QUERY_PARAM_KEYS = new Set([
  'direction',
  'offset',
  'orderBy',
  'page',
  'perPage',
  'size'
]);

const USER_FILTER = 'userFilter';

const normalizeValue = value => (typeof value === 'string' ? value.trim() : value);

const hasValue = value => {
  const normalizedValue = normalizeValue(value);

  return normalizedValue !== '' && normalizedValue !== null && normalizedValue !== undefined;
};

const getCompaniesLabel = companiesCount =>
  (companiesCount === 1 ? CompanyEntity.singular : CompanyEntity.plural).toLocaleLowerCase();

export const hasFiltersApplied = queryParams => {
  const params = new URLSearchParams(queryParams?.params || '');

  return Array.from(params.entries()).some(([key, value]) => {
    if (key === USER_FILTER) return normalizeValue(value) !== String(ListingFilters.Mine);
    if (NON_FILTER_QUERY_PARAM_KEYS.has(key)) return false;

    return hasValue(value);
  });
};

export const getExtractionAlertConfig = ({
  extractionCompaniesCount,
  hasCompaniesToExtract,
  hasExtractableCompaniesCountError,
  hasFiltersAppliedForExtraction,
  isLoadingCompaniesToExtractCount,
  shouldExtractCompanyContacts
}) => {
  if (!shouldExtractCompanyContacts) return null;

  if (hasExtractableCompaniesCountError) {
    return {
      severity: 'warning',
      message: formCopies.sections.extractCompaniesContacts.countLoadErrorHint
    };
  }

  if (!isLoadingCompaniesToExtractCount && !hasCompaniesToExtract) {
    return {
      severity: 'warning',
      message: formCopies.sections.extractCompaniesContacts.noCompaniesHint
    };
  }

  if (
    hasFiltersAppliedForExtraction &&
    !isLoadingCompaniesToExtractCount &&
    hasCompaniesToExtract
  ) {
    return {
      companiesCount: extractionCompaniesCount,
      companiesLabel: getCompaniesLabel(extractionCompaniesCount),
      message: formCopies.sections.extractCompaniesContacts.filtersHint,
      severity: 'info'
    };
  }

  return null;
};
